import service from '@/utils/server';
let modelPath = '/mytask/mytask';
export const initPage = data => {
    return service({
        url: modelPath+'/initPage',
        method: 'post',
        data
    })
};



// WEBPACK FOOTER //
// ./src/page/mytask/mytask/api/index.js